import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import { RPE_INTENSITY_RANGES } from '../../../utils/trainingLoadCalculations';

const getHooperColor = (score) => {
  if (score <= 12) return '#22C55E';
  if (score <= 16) return '#3B82F6';
  if (score <= 20) return '#F59E0B';
  return '#EF4444';
};

const getHooperCategory = (score) => {
  if (score <= 12) return 'Excellent';
  if (score <= 16) return 'Good';
  if (score <= 20) return 'Fair';
  return 'Poor';
};

const TrainingLoadWellnessChart = ({ data, width = 678, height = 300 }) => {
  return (
    <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
      <ComposedChart 
        width={width} 
        height={height} 
        data={data}
        margin={{ top: 5, right: 60, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
        <XAxis 
          dataKey="date" 
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          interval="preserveStartEnd"
        />
        <YAxis 
          yAxisId="load"
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          label={{ value: 'Load (AU)', angle: -90, position: 'insideLeft', dx: 14, style: { fontSize: '11px', textAnchor: 'middle' } }}
        />
        <YAxis 
          yAxisId="wellness"
          orientation="right"
          domain={[4, 28]}
          ticks={[4, 12, 20, 28]}
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          label={{ value: 'Wellness', angle: 90, position: 'insideRight', dx: -25, style: { fontSize: '11px', textAnchor: 'middle' } }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }}
          iconType="rect"
        />
        <Bar 
          yAxisId="load" 
          dataKey="lowLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.LOW?.color}
          name="Low (RPE 1-3)"
        />
        <Bar 
          yAxisId="load" 
          dataKey="moderateLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.MODERATE?.color}
          name="Moderate (RPE 4-6)"
        />
        <Bar 
          yAxisId="load" 
          dataKey="highLoad" 
          stackId="load" 
          fill={RPE_INTENSITY_RANGES?.HIGH?.color}
          name="Hard (RPE 7-10)"
        />
        <Line 
          yAxisId="wellness" 
          type="monotone" 
          dataKey="wellness" 
          stroke="#8B5CF6" 
          strokeWidth={2}
          name="Wellness (Hooper)"
          dot={(props) => {
            if (!props?.payload?.wellness) return null;
            const color = getHooperColor(props?.payload?.wellness);
            return (
              <circle 
                cx={props?.cx} 
                cy={props?.cy} 
                r={4} 
                fill={color}
                strokeWidth={2}
                stroke={color}
              />
            );
          }}
        />
      </ComposedChart>
      {/* Wellness Category Legend */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '8px', fontSize: '9px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22C55E' }} />
          <span>Excellent (≤12)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#3B82F6' }} />
          <span>Good (13-16)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#F59E0B' }} />
          <span>Fair (17-20)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#EF4444' }} />
          <span>Poor (≥21)</span>
        </div>
      </div>
    </div>
  );
};

export default TrainingLoadWellnessChart;